

























import { Component, Vue } from 'vue-property-decorator';
import VWrapper from '@/components/shared/VWrapper.vue';
import { namespace } from 'vuex-class';
import { Venue } from '@/interfaces/models/Venue';
import VenueTable from '@/components/venue/VenueTable.vue';
import VConfirm from '@/components/shared/VConfirm.vue';
import { Permission } from '@/enums/Permission';
import Filter from '@/interfaces/api/Filter';
import OrderServiceApi from '@/api/http/OrderServiceApi';
import { AxiosResponse } from 'axios';
import { toUrl } from '@/util/helper';
import moment from 'moment';
import DataApiService from '@/api/http/DataApiService';

const venue = namespace('venue');

@Component({
  components: { VConfirm, VenueTable, VWrapper },
})
export default class Venues extends Vue {
  @venue.Action('fetch') public getVenues!: any;
  @venue.Action('destroy') public deleteVenue!: any;
  @venue.Action('softDelete') public archive!: any;
  @venue.Action('setFilter') public setVenueFilter!: any;
  @venue.State('items') public venues!: Venue[];
  @venue.State((state) => state.pagination.total) public total!: number;
  @venue.State('filter') public venueFilter!: Filter;

  public async created() {
    this.$startLoading('venue');
    await this.getVenues({ page: 1 });
    this.$stopLoading('venue');
  }

  public create() {
    if (this.$can(Permission.VENUE_CREATE)) {
      this.$router.push({ name: 'venue.create' });
    } else {
      this.$router.push({ name: 'venue.createSimple' });
    }
  }

  public async destroy(venue: Venue) {
    this.$startLoading('venue');
    await this.deleteVenue({ id: venue._id });
    this.$stopLoading('venue');
  }

  public exportCsv() {
    this.$startLoading('venueCsv');
    const api: DataApiService = new DataApiService();
    api
      .getVenueCsv(this.venueFilter, this.$i18n.locale)
      .then((res: AxiosResponse) => toUrl(res.data, `venues-${moment().format('DD-MM-YYYY')}.csv`))
      .finally(() => {
        this.$stopLoading('venueCsv');
      });
  }

  public async filter(filter: Filter) {
    this.$startLoading('venue');
    this.setVenueFilter(filter);
    await this.getVenues({ page: 1 });
    this.$stopLoading('venue');
  }
}
